import $ from 'jquery'
import Toggler from 'luminate/src/modules/toggler'

Toggler.events.toggle = function(e)
{
	if(!e.transition && this.$settings.transition === 'height')
	{
		this.$element.style.display = (this.showing ? '' : 'none')
	}
}

const superTransitionStart = Toggler.events.transitionStart
Toggler.events.transitionStart = function()
{
	superTransitionStart.call(this)

	const Module = this.constructor

	if(this.$settings.transition === 'height')
	{
		const $element = $(this.$element)
		const complete = function()
		{
			Module.trigger('transitionEnd', {target: this})
		}.bind(this)

		if(this.showing)
		{
			$element.slideDown(400, complete)
		}
		else
		{
			$element.slideUp(400, complete)
		}
	}
}



// WEBPACK FOOTER //
// ./source/scripts/legacy/extensions/toggler.js